export const ROUTE_PATHS = {
  HOME: '/',
} as const;

export interface Testimonio {
  id: string;
  nombre: string;
  profesion?: string;
  comentario: string;
  imagen: string;
  mejora: string;
}

export interface Beneficio {
  id: string;
  titulo: string;
  descripcion: string;
  icono: string;
}

export interface Caracteristica {
  id: string;
  titulo: string;
  descripcion: string;
  icono: string;
}

export const NAV_LINKS = [
  { label: 'Inicio', href: '#hero' },
  { label: 'El Programa', href: '#programa' },
  { label: 'Beneficios', href: '#beneficios' },
  { label: 'Testimonios', href: '#testimonios' },
  { label: 'Contacto', href: '#contacto' },
];

export const BENEFICIOS_LIST: Beneficio[] = [
  {
    id: 'b1',
    titulo: 'Adiós a las Molestias',
    descripcion: 'Ejercicios diseñados para reducir el dolor crónico y mejorar la movilidad de forma progresiva.',
    icono: 'ShieldCheck',
  },
  {
    id: 'b2',
    titulo: 'Recupera tu Energía',
    descripcion: 'Vuelve a sentirte vital en tu día a día optimizando tu descanso recuperando tus ritmos circadianos.',
    icono: 'Zap',
  },
  {
    id: 'b3',
    titulo: 'Soporte en Comunidad',
    descripcion: 'Pregunta, envía vídeos y resuelve todas tus dudas dentro de la comunidad privada.',
    icono: 'Users',
  },
  {
    id: 'b4',
    titulo: 'Solo 10€ al Mes',
    descripcion: 'Menos de lo que gastas en cafés al mes. Puedes cancelar cuando quieras sin ningún problema.',
    icono: 'Euro',
  },
];

export const TESTIMONIOS_LIST: Testimonio[] = [
  {
    id: 't1',
    nombre: 'Carlos Rodríguez',
    profesion: 'Ingeniero, 45 años',
    comentario: 'Después de años con dolor de espalda, el Programa Recupera me devolvió la capacidad de jugar con mis hijos sin miedo.',
    imagen: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=200&h=200',
    mejora: 'Adiós al dolor lumbar',
  },
  {
    id: 't2',
    nombre: 'Elena Martínez',
    profesion: 'Diseñadora, 32 años',
    comentario: 'La app es increíble. Tener los videos explicados y subtitulados me ayudó a no cometer errores en las posturas.',
    imagen: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=200&h=200',
    mejora: 'Más energía diaria',
  },
  {
    id: 't3',
    nombre: 'Javier Sanz',
    profesion: 'Arquitecto, 52 años',
    comentario: 'Los ejercicios de respiración fueron el gran descubrimiento. Mi estrés ha bajado y mi forma física ha mejorado notablemente.',
    imagen: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=200&h=200',
    mejora: 'Movilidad recuperada',
  },
];

export const CARACTERISTICAS_PROGRAMA: Caracteristica[] = [
  {
    id: 'c1',
    titulo: 'Planificación de 12 Meses',
    descripcion: 'Un viaje estructurado mes a mes para una transformación real y duradera.',
    icono: 'Calendar',
  },
  {
    id: 'c2',
    titulo: 'Todo en tu Móvil',
    descripcion: 'Accede a tus rutinas y documentos de apoyo en cualquier momento desde nuestra App.',
    icono: 'Smartphone',
  },
  {
    id: 'c3',
    titulo: 'Videos Explicativos',
    descripcion: 'Todos los ejercicios están grabados y subtitulados para que entrenes con total seguridad.',
    icono: 'PlayCircle',
  },
  {
    id: 'c4',
    titulo: 'Enfoque Integral',
    descripcion: 'Combinamos entrenamiento físico, técnicas de respiración y gestión de hábitos.',
    icono: 'Activity',
  },
];

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
  }).format(amount);
}

export function scrollToAnchor(id: string): void {
  const element = document.getElementById(id.replace('#', ''));
  if (element) {
    const offset = 80;
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element.getBoundingClientRect().top;
    const elementPosition = elementRect - bodyRect;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }
}
